<template>
  <chapter-dropdown
    v-if="hasAssets"
    :defaultChapter="!isCustomChapter"
    :chapterDetails="chapterDetails"
    :chapterAssets="sortedAssets"
    :chapterProgress="chapterProgress"
    :containsActiveAsset="containsActiveAsset"
  ></chapter-dropdown>
</template>

<style scoped>
ul {
  list-style: none;
  padding: 0;
}
</style>

<script>
import SingleChapterMixin from '@mixins/single-chapter-mixin';
import { sortObjectArray } from '@utils/sort-by-object-property';
import { assetMatchesRoute } from '@utils/current-asset-from-route';
import ChapterDropdown from './chapter-dropdown.vue';

export default {
  components: {
    ChapterDropdown,
  },

  mixins: [SingleChapterMixin],

  props: {
    chapter: {
      type: Object,
      required: true,
    },
    moduleName: {
      type: String,
      required: true,
    },
  },

  computed: {
    chapterDetails() {
      return {
        name: this.chapter.name,
        label: this.chapter.label,
        number: this.chapter.number,
      };
    },

    sortedAssets() {
      if (this.chapter.name === 'Events') {
        return sortObjectArray(this.assets, 'event_start');
      }
      if (this.moduleName === 'Meetings' && this.chapter.name === 'Meetings') {
        return sortObjectArray(this.assets, 'meeting_start');
      }
      return this.assets;
    },

    containsActiveAsset() {
      return this.sortedAssets.some(asset => assetMatchesRoute(asset, this.$route));
    },
  },
};
</script>
